import FuzzySet from "fuzzyset";
import _ from "underts";
const synoMap = {
    douleur: ["mal", "sensibilité", "sensible", "sensibles", "douleurs", "mâche"],
    cassé: ["cassée", "cassées"],
    trou: ["trous", "trou"],
    gencive: ["gencives", "gencive"],
    gonflement: ["gonflée", "gonflé", "abcès"],
    saignement: ["saigne", "saignements", "sang"],
    carie: ["cariées", "cariée", "caries"],
    mobilité: ["mobile", "mobiles", "bouge", "bougent"],
    absente: [
        "absent",
        "absents",
        "absentes",
        "manquante",
        "manquantes",
        "manquant",
        "manquants",
        "manque",
        "remplacer",
    ],
    implant: ["implants"],
    couronne: ["couronnes"],
    descellement: [
        "descellements",
        "perdu",
        "perdue",
        "perdus",
        "perdues",
        "tombé",
        "tombée",
        "tombés",
        "tombées",
    ],
    esthétique: [
        "esthétiques",
        "esthétique",
        "aspect",
        "blancheur",
        "blanc",
        "blancs",
        "blanche",
        "blanches",
        "blanchiment",
        "blanchir",
    ],
    bilan: ["bilan", "examen", "plein", "beaucoup", "devis"],
    extraction: [
        "arrachage",
        "arracher",
        "retirer",
        "retirée",
        "retirées",
        "retirés",
        "retirer",
        "extraire",
        "extraction",
    ],
    détartrage: ["détartrage", "détartrer", "détarté", "détartage", "détatrer"],
    contrôle: [
        "contrôle",
        "contrôler",
        "routine",
        "vérification",
        "vérifier",
        "visite",
        "annuelle",
        "annuel",
        "mtdents",
    ],
    autre: [],
};
const keywordsToMotifsMap = {
    douleur: ["DLR"],
    cassé: ["DKCTROU"],
    trou: ["DKCTROU"],
    gencive: ["GENCIVE"],
    gonflement: ["GENCIVE"],
    saignement: ["GENCIVE"],
    carie: ["CARIE"],
    mobilité: ["PARO"],
    absente: ["IMPLANT", "BILAN"],
    implant: ["IMPLANT"],
    couronne: ["COUR"],
    descellement: ["RESC", "COUR"],
    esthétique: ["BILAN"],
    bilan: ["CTRL", "BILAN"],
    extraction: ["EXTRAC"],
    détartrage: ["DET"],
    contrôle: ["CTRL", "BILAN"],
    autre: ["AUTRE"],
};
const fouzyset = FuzzySet(Object.values(synoMap).flat(), true, 3, 3);
const demandeKeywords = [
    "douleur",
    "cassé",
    "trou",
    "gonflement",
    "gencive",
    "carie",
    "mobilité",
    "absente",
    "implant",
    "couronne",
    "descellement",
    "esthétique",
    "bilan",
    "extraction",
    "saignement",
    "détartrage",
    "contrôle",
    "autre",
];
function lowerCase(word) {
    return word.toLowerCase();
}
const useless = [
    "des",
    "où",
    "ou",
    "le",
    "la",
    "les",
    "ma",
    "mon",
    "mes",
    "trop",
    "un",
    "une",
    "dans",
    "j'ai",
];
function isUsefull(word) {
    return !useless.includes(word);
}
function fuzzyTranslate(word) {
    const candidates = fouzyset.get(word, undefined, 0.55);
    if (!candidates) {
        return word;
    }
    if (!_.isNonEmpty(candidates)) {
        return word;
    }
    return _.head(candidates)[1];
}
function inputToDemandeKeyWords(input) {
    const result = new Set();
    const translatedInput = input
        .split(" ")
        .map(lowerCase)
        .filter(isUsefull)
        .map(fuzzyTranslate)
        .join(" ");
    for (const keyword of demandeKeywords) {
        if (translatedInput.includes(keyword) ||
            synoMap[keyword].some((syno) => translatedInput.includes(syno))) {
            result.add(keyword);
        }
    }
    return result;
}
/**
 * Translates an array of DemandeKeywords into an array of MotifsKeys
 * using the keywordsToMotifsMap mapping.
 */
export function demandeKeywordsToMotifs(demandeKeywords) {
    const motifsSet = new Set();
    for (const keyword of demandeKeywords) {
        const motifs = keywordsToMotifsMap[keyword];
        for (const motif of motifs) {
            motifsSet.add(motif);
        }
    }
    return Array.from(motifsSet);
}
export default inputToDemandeKeyWords;
//# sourceMappingURL=inputToDemandeKeyWords.js.map